import { z } from "zod/v4-mini";

import { Schema, cz } from "@/utils/zodUtils.ts";

export const glycemiaDataDisplayTypeSchema = z.literal(["continuous", "logbook"]);
export type GlycemiaDataDisplayType = z.infer<typeof glycemiaDataDisplayTypeSchema>;
export const glycemiaIndicatorsDisplayTypeSchema = z.literal(["bgm", "cgm"]);
export type GlycemiaIndicatorsDisplayType = z.infer<typeof glycemiaIndicatorsDisplayTypeSchema>;
export const insulinDataDisplayTypeSchema = z.literal(["discrete", "continuous", "closed_loop"]);
export type InsulinDataDisplayType = z.infer<typeof insulinDataDisplayTypeSchema>;
export const insulinIndicatorsDisplayTypeSchema = z.literal(["discrete", "continuous", "closed_loop"]);
export type InsulinIndicatorsDisplayType = z.infer<typeof insulinIndicatorsDisplayTypeSchema>;

export type DiabetesDataDisplayParams = {
  glycemiaDataDisplayMode?: GlycemiaDataDisplayType;
  insulinDataDisplayMode?: InsulinDataDisplayType;
  glycemiaIndicatorsDisplayMode?: GlycemiaIndicatorsDisplayType;
  insulinIndicatorsDisplayMode?: InsulinIndicatorsDisplayType;
  glycemiaDeviceName?: string;
  isMedtronicClosedLoop?: boolean;
};

export const diabetesDisplayModeSchema: Schema<DiabetesDataDisplayParams> = cz.camelCaseObject({
  glycemia_data_display_mode: cz.optional(glycemiaDataDisplayTypeSchema),
  insulin_data_display_mode: cz.optional(insulinDataDisplayTypeSchema),
  glycemia_indicators_display_mode: cz.optional(glycemiaIndicatorsDisplayTypeSchema),
  insulin_indicators_display_mode: cz.optional(insulinIndicatorsDisplayTypeSchema),
  glycemia_device_name: cz.optional(z.string()),
  is_medtronic_closed_loop: cz.optional(z.boolean()),
});
